import { Link } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { ArrowRight } from "lucide-react";
import EventoPublicoCard from "@/components/common/EventoPublicoCard";
import { getEventosVisiblesParaSocio, hidratarEventosPublicos } from "@/data/adminEventosStore";
import { PUBLIC } from "@/constants/testIds";

/**
 * Home pública · lo que ve cualquier persona sin sesión.
 * Sin barra inferior. Sólo información y accesos.
 */
export default function HomePublica() {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    hidratarEventosPublicos().then(() => setTick((t) => t + 1));
  }, []);
  const eventos = useMemo(() => getEventosVisiblesParaSocio(), [tick]);
  return (
    <div data-testid={PUBLIC.homeScreen} className="flex flex-col gap-14">
      {/* Hero */}
      <section className="animate-fade-up flex flex-col gap-6 max-w-2xl">
        <span className="overline text-accent">Bienvenido</span>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-foreground">
          Casino Tampiqueño,
          <br />
          <span className="italic text-primary dark:text-accent">a un toque</span>.
        </h1>
        <p className="text-muted-foreground leading-relaxed max-w-xl">
          Consulta información, próximos eventos y accede a tu experiencia como socio.
        </p>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 pt-2">
          <Link
            to="/login"
            data-testid={PUBLIC.ctaLogin}
            className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-medium bg-primary text-primary-foreground dark:bg-accent dark:text-accent-foreground ring-1 ring-primary/20 dark:ring-accent/40 shadow-soft transition-all duration-200 active:scale-[0.98] hover:opacity-90"
          >
            Iniciar sesión
            <ArrowRight className="w-4 h-4" strokeWidth={2} />
          </Link>
          <a
            href="#proximos-eventos"
            data-testid={PUBLIC.ctaEventos}
            className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-medium border hairline bg-card text-foreground transition-all duration-200 hover:bg-muted"
          >
            Conocer eventos
          </a>
        </div>
      </section>

      <div className="divider-gold max-w-24" />

      {/* Próximos eventos */}
      <section
        id="proximos-eventos"
        data-testid={PUBLIC.eventosSection}
        className="animate-fade-up delay-100 flex flex-col gap-6 scroll-mt-24"
      >
        <header className="flex flex-col gap-2">
          <span className="overline text-accent">Agenda</span>
          <h2 className="font-heading text-2xl sm:text-3xl text-foreground">
            Próximos eventos
          </h2>
          <p className="text-sm text-muted-foreground max-w-xl">
            Una selección de las experiencias que se avecinan en el club.
          </p>
        </header>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {eventos.length === 0 && (
            <p className="text-sm text-muted-foreground">
              Aún no hay eventos publicados.
            </p>
          )}
          {eventos.map((ev) => (
            <EventoPublicoCard
              key={ev.id}
              evento={ev}
              testId={`evento-publico-${ev.id}`}
            />
          ))}
        </div>
      </section>

      <p className="text-xs text-muted-foreground/80">
        Fundado en la tradición, presente en cada detalle.
      </p>
    </div>
  );
}
